/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { AttestationType } from '../models/attestation-type';
import { CommonDetails } from '../models/common-details';
import { DeviceCountDto } from '../models/device-count-dto';
import { GroupDto } from '../models/group-dto';
import { GroupEnrollmentDto } from '../models/group-enrollment-dto';
import { GroupEnrollmentStatusResponseDto } from '../models/group-enrollment-status-response-dto';
import { GroupSearchtDto } from '../models/group-searcht-dto';
import { IndividualEnrollmentDto } from '../models/individual-enrollment-dto';
import { Resource } from '../models/resource';
import { SearchDto } from '../models/search-dto';

@Injectable({
  providedIn: 'root',
})
export class DeviceEnrollmentControllerService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getDeviceCetegories
   */
  static readonly GetDeviceCetegoriesPath = '/api/v1/device/categories';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getDeviceCetegories()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDeviceCetegories$Response(params?: {
  }): Observable<StrictHttpResponse<Array<CommonDetails>>> {

    const rb = new RequestBuilder(this.rootUrl, DeviceEnrollmentControllerService.GetDeviceCetegoriesPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<CommonDetails>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getDeviceCetegories$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDeviceCetegories(params?: {
  }): Observable<Array<CommonDetails>> {

    return this.getDeviceCetegories$Response(params).pipe(
      map((r: StrictHttpResponse<Array<CommonDetails>>) => r.body as Array<CommonDetails>)
    );
  }

  /**
   * Path part for operation getdownloadCsv
   */
  static readonly GetdownloadCsvPath = '/api/v1/enrollment/csvTemplate';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getdownloadCsv()` instead.
   *
   * This method doesn't expect any request body.
   */
  getdownloadCsv$Response(params?: {
    deviceIntfProviderId?: string;
    categoryId?: string;
  }): Observable<StrictHttpResponse<CommonDetails>> {

    const rb = new RequestBuilder(this.rootUrl, DeviceEnrollmentControllerService.GetdownloadCsvPath, 'get');
    if (params) {
      rb.query('deviceIntfProviderId', params.deviceIntfProviderId, {});
      rb.query('categoryId', params.categoryId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CommonDetails>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getdownloadCsv$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getdownloadCsv(params?: {
    deviceIntfProviderId?: string;
    categoryId?: string;
  }): Observable<CommonDetails> {

    return this.getdownloadCsv$Response(params).pipe(
      map((r: StrictHttpResponse<CommonDetails>) => r.body as CommonDetails)
    );
  }

  /**
   * Path part for operation getAttestationData
   */
  static readonly GetAttestationDataPath = '/api/v1/attestationType/name/{name}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAttestationData()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAttestationData$Response(params: {
    name: string;
  }): Observable<StrictHttpResponse<AttestationType>> {

    const rb = new RequestBuilder(this.rootUrl, DeviceEnrollmentControllerService.GetAttestationDataPath, 'get');
    if (params) {
      rb.path('name', params.name, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AttestationType>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getAttestationData$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAttestationData(params: {
    name: string;
  }): Observable<AttestationType> {

    return this.getAttestationData$Response(params).pipe(
      map((r: StrictHttpResponse<AttestationType>) => r.body as AttestationType)
    );
  }

  /**
   * Path part for operation tzDeleteEnrolledDevice
   */
  static readonly TzDeleteEnrolledDevicePath = '/api/v1/enrolledDevice/{imei}';

  /**
   * Delete Enrolled Device.
   *
   * The api deletes the specific enrolled device for the given imei
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tzDeleteEnrolledDevice()` instead.
   *
   * This method doesn't expect any request body.
   */
  tzDeleteEnrolledDevice$Response(params: {
    imei: string;
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, DeviceEnrollmentControllerService.TzDeleteEnrolledDevicePath, 'delete');
    if (params) {
      rb.path('imei', params.imei, {});
    }

    return this.http.request(rb.build({
       responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Delete Enrolled Device.
   *
   * The api deletes the specific enrolled device for the given imei
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `tzDeleteEnrolledDevice$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  tzDeleteEnrolledDevice(params: {
    imei: string;
  }): Observable<void> {

    return this.tzDeleteEnrolledDevice$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation getGrpEnrollDeviceCount
   */
  static readonly GetGrpEnrollDeviceCountPath = '/api/v1/groupenrollmentdetails/{groupId}/device/count';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getGrpEnrollDeviceCount()` instead.
   *
   * This method doesn't expect any request body.
   */
  getGrpEnrollDeviceCount$Response(params: {
    groupId: string;
  }): Observable<StrictHttpResponse<Array<DeviceCountDto>>> {

    const rb = new RequestBuilder(this.rootUrl, DeviceEnrollmentControllerService.GetGrpEnrollDeviceCountPath, 'get');
    if (params) {
      rb.path('groupId', params.groupId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<DeviceCountDto>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getGrpEnrollDeviceCount$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getGrpEnrollDeviceCount(params: {
    groupId: string;
  }): Observable<Array<DeviceCountDto>> {

    return this.getGrpEnrollDeviceCount$Response(params).pipe(
      map((r: StrictHttpResponse<Array<DeviceCountDto>>) => r.body as Array<DeviceCountDto>)
    );
  }

  /**
   * Path part for operation getDeviceEnrollStatus
   */
  static readonly GetDeviceEnrollStatusPath = '/api/v1/groupenrollmentdetails/{groupId}/enroll';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getDeviceEnrollStatus()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDeviceEnrollStatus$Response(params: {
    groupId: string;
    page?: number;
    limit?: number;
    status?: string;
    deviceSerialNo?: string;
  }): Observable<StrictHttpResponse<GroupEnrollmentStatusResponseDto>> {

    const rb = new RequestBuilder(this.rootUrl, DeviceEnrollmentControllerService.GetDeviceEnrollStatusPath, 'get');
    if (params) {
      rb.path('groupId', params.groupId, {});
      rb.query('page', params.page, {});
      rb.query('limit', params.limit, {});
      rb.query('status', params.status, {});
      rb.query('deviceSerialNo', params.deviceSerialNo, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<GroupEnrollmentStatusResponseDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getDeviceEnrollStatus$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDeviceEnrollStatus(params: {
    groupId: string;
    page?: number;
    limit?: number;
    status?: string;
    deviceSerialNo?: string;
  }): Observable<GroupEnrollmentStatusResponseDto> {

    return this.getDeviceEnrollStatus$Response(params).pipe(
      map((r: StrictHttpResponse<GroupEnrollmentStatusResponseDto>) => r.body as GroupEnrollmentStatusResponseDto)
    );
  }

  /**
   * Path part for operation getDeviceEnrollErrorLog
   */
  static readonly GetDeviceEnrollErrorLogPath = '/api/v1/{deviceSerialNo}/log';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getDeviceEnrollErrorLog()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDeviceEnrollErrorLog$Response(params: {
    deviceSerialNo: string;
  }): Observable<StrictHttpResponse<Resource>> {

    const rb = new RequestBuilder(this.rootUrl, DeviceEnrollmentControllerService.GetDeviceEnrollErrorLogPath, 'get');
    if (params) {
      rb.path('deviceSerialNo', params.deviceSerialNo, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Resource>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getDeviceEnrollErrorLog$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDeviceEnrollErrorLog(params: {
    deviceSerialNo: string;
  }): Observable<Resource> {

    return this.getDeviceEnrollErrorLog$Response(params).pipe(
      map((r: StrictHttpResponse<Resource>) => r.body as Resource)
    );
  }

  /**
   * Path part for operation createIndividualEnrollment
   */
  static readonly CreateIndividualEnrollmentPath = '/api/v1/individualEnrollment';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createIndividualEnrollment()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createIndividualEnrollment$Response(params?: {
    body?: IndividualEnrollmentDto
  }): Observable<StrictHttpResponse<IndividualEnrollmentDto>> {

    const rb = new RequestBuilder(this.rootUrl, DeviceEnrollmentControllerService.CreateIndividualEnrollmentPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<IndividualEnrollmentDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `createIndividualEnrollment$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createIndividualEnrollment(params?: {
    body?: IndividualEnrollmentDto
  }): Observable<IndividualEnrollmentDto> {

    return this.createIndividualEnrollment$Response(params).pipe(
      map((r: StrictHttpResponse<IndividualEnrollmentDto>) => r.body as IndividualEnrollmentDto)
    );
  }

  /**
   * Path part for operation createGroupEnrollment
   */
  static readonly CreateGroupEnrollmentPath = '/api/v1/groupEnrollment';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createGroupEnrollment()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  createGroupEnrollment$Response(params: {
    metaData: string;
    body?: {
'multipartFile'?: Blob;
}
  }): Observable<StrictHttpResponse<GroupEnrollmentDto>> {

    const rb = new RequestBuilder(this.rootUrl, DeviceEnrollmentControllerService.CreateGroupEnrollmentPath, 'post');
    if (params) {
      rb.query('metaData', params.metaData, {});
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<GroupEnrollmentDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `createGroupEnrollment$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  createGroupEnrollment(params: {
    metaData: string;
    body?: {
'multipartFile'?: Blob;
}
  }): Observable<GroupEnrollmentDto> {

    return this.createGroupEnrollment$Response(params).pipe(
      map((r: StrictHttpResponse<GroupEnrollmentDto>) => r.body as GroupEnrollmentDto)
    );
  }

  /**
   * Path part for operation getGroupEnrollmentOnBusinessProfile
   */
  static readonly GetGroupEnrollmentOnBusinessProfilePath = '/api/v1/grouponbusinessprofile';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getGroupEnrollmentOnBusinessProfile()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getGroupEnrollmentOnBusinessProfile$Response(params?: {
    page?: number;
    limit?: number;
    body?: GroupSearchtDto
  }): Observable<StrictHttpResponse<Array<GroupDto>>> {

    const rb = new RequestBuilder(this.rootUrl, DeviceEnrollmentControllerService.GetGroupEnrollmentOnBusinessProfilePath, 'post');
    if (params) {
      rb.query('page', params.page, {});
      rb.query('limit', params.limit, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<GroupDto>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getGroupEnrollmentOnBusinessProfile$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getGroupEnrollmentOnBusinessProfile(params?: {
    page?: number;
    limit?: number;
    body?: GroupSearchtDto
  }): Observable<Array<GroupDto>> {

    return this.getGroupEnrollmentOnBusinessProfile$Response(params).pipe(
      map((r: StrictHttpResponse<Array<GroupDto>>) => r.body as Array<GroupDto>)
    );
  }

  /**
   * Path part for operation getGroupEnrollmentOnSolutionType
   */
  static readonly GetGroupEnrollmentOnSolutionTypePath = '/api/v1/grouponsolutiontype';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getGroupEnrollmentOnSolutionType()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getGroupEnrollmentOnSolutionType$Response(params?: {
    page?: number;
    limit?: number;
    body?: GroupSearchtDto
  }): Observable<StrictHttpResponse<Array<GroupDto>>> {

    const rb = new RequestBuilder(this.rootUrl, DeviceEnrollmentControllerService.GetGroupEnrollmentOnSolutionTypePath, 'post');
    if (params) {
      rb.query('page', params.page, {});
      rb.query('limit', params.limit, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<GroupDto>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getGroupEnrollmentOnSolutionType$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getGroupEnrollmentOnSolutionType(params?: {
    page?: number;
    limit?: number;
    body?: GroupSearchtDto
  }): Observable<Array<GroupDto>> {

    return this.getGroupEnrollmentOnSolutionType$Response(params).pipe(
      map((r: StrictHttpResponse<Array<GroupDto>>) => r.body as Array<GroupDto>)
    );
  }

  /**
   * Path part for operation getGroupEnrollmenCount
   */
  static readonly GetGroupEnrollmenCountPath = '/api/v1/groupEnrollment/count';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getGroupEnrollmenCount()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getGroupEnrollmenCount$Response(params: {
    searchtype: string;
    body?: GroupSearchtDto
  }): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, DeviceEnrollmentControllerService.GetGroupEnrollmenCountPath, 'post');
    if (params) {
      rb.query('searchtype', params.searchtype, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getGroupEnrollmenCount$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getGroupEnrollmenCount(params: {
    searchtype: string;
    body?: GroupSearchtDto
  }): Observable<number> {

    return this.getGroupEnrollmenCount$Response(params).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

  /**
   * Path part for operation findAllGroupNamesBasedOnSolutionType
   */
  static readonly FindAllGroupNamesBasedOnSolutionTypePath = '/api/v1/solutiontype/{id}/groupEnrollment';

  /**
   * GET All Group Names.
   *
   * The api fetches all the Group Names for the given solution type ID
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findAllGroupNamesBasedOnSolutionType()` instead.
   *
   * This method doesn't expect any request body.
   */
  findAllGroupNamesBasedOnSolutionType$Response(params: {
    id: string;
    active?: string;
  }): Observable<StrictHttpResponse<Array<CommonDetails>>> {

    const rb = new RequestBuilder(this.rootUrl, DeviceEnrollmentControllerService.FindAllGroupNamesBasedOnSolutionTypePath, 'get');
    if (params) {
      rb.path('id', params.id, {});
      rb.query('active', params.active, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<CommonDetails>>;
      })
    );
  }

  /**
   * GET All Group Names.
   *
   * The api fetches all the Group Names for the given solution type ID
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findAllGroupNamesBasedOnSolutionType$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findAllGroupNamesBasedOnSolutionType(params: {
    id: string;
    active?: string;
  }): Observable<Array<CommonDetails>> {

    return this.findAllGroupNamesBasedOnSolutionType$Response(params).pipe(
      map((r: StrictHttpResponse<Array<CommonDetails>>) => r.body as Array<CommonDetails>)
    );
  }

  /**
   * Path part for operation activateGroup
   */
  static readonly ActivateGroupPath = '/api/v1/groupEnrollment/{id}/activate';

  /**
   * Activate Group.
   *
   * The API activates the specific Group for the given ID
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `activateGroup()` instead.
   *
   * This method doesn't expect any request body.
   */
  activateGroup$Response(params: {
    id: string;
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, DeviceEnrollmentControllerService.ActivateGroupPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
       responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Activate Group.
   *
   * The API activates the specific Group for the given ID
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `activateGroup$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  activateGroup(params: {
    id: string;
  }): Observable<void> {

    return this.activateGroup$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation deactivateGroup
   */
  static readonly DeactivateGroupPath = '/api/v1/groupEnrollment/{id}/deactivate';

  /**
   * Deactivate Group.
   *
   * The API deactivates the specific Group for the given ID
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deactivateGroup()` instead.
   *
   * This method doesn't expect any request body.
   */
  deactivateGroup$Response(params: {
    id: string;
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, DeviceEnrollmentControllerService.DeactivateGroupPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
       responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Deactivate Group.
   *
   * The API deactivates the specific Group for the given ID
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `deactivateGroup$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deactivateGroup(params: {
    id: string;
  }): Observable<void> {

    return this.deactivateGroup$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation findAllGroupNamesBasedOnDeviceType
   */
  static readonly FindAllGroupNamesBasedOnDeviceTypePath = '/api/v1/devicetype/{id}/groupEnrollment';

  /**
   * GET All Group Names.
   *
   * The api fetches all the Group Names for the given Device Type ID
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findAllGroupNamesBasedOnDeviceType()` instead.
   *
   * This method doesn't expect any request body.
   */
  findAllGroupNamesBasedOnDeviceType$Response(params: {
    id: string;
    active?: string;
  }): Observable<StrictHttpResponse<Array<CommonDetails>>> {

    const rb = new RequestBuilder(this.rootUrl, DeviceEnrollmentControllerService.FindAllGroupNamesBasedOnDeviceTypePath, 'get');
    if (params) {
      rb.path('id', params.id, {});
      rb.query('active', params.active, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<CommonDetails>>;
      })
    );
  }

  /**
   * GET All Group Names.
   *
   * The api fetches all the Group Names for the given Device Type ID
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findAllGroupNamesBasedOnDeviceType$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findAllGroupNamesBasedOnDeviceType(params: {
    id: string;
    active?: string;
  }): Observable<Array<CommonDetails>> {

    return this.findAllGroupNamesBasedOnDeviceType$Response(params).pipe(
      map((r: StrictHttpResponse<Array<CommonDetails>>) => r.body as Array<CommonDetails>)
    );
  }

  /**
   * Path part for operation findAllFirmware
   */
  static readonly FindAllFirmwarePath = '/api/v1/devicefirmware';

  /**
   * GET All Firmware.
   *
   * The api fetches all the Firmware for the given Solution, Device and Group IDs
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findAllFirmware()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  findAllFirmware$Response(params?: {
    body?: SearchDto
  }): Observable<StrictHttpResponse<Array<CommonDetails>>> {

    const rb = new RequestBuilder(this.rootUrl, DeviceEnrollmentControllerService.FindAllFirmwarePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<CommonDetails>>;
      })
    );
  }

  /**
   * GET All Firmware.
   *
   * The api fetches all the Firmware for the given Solution, Device and Group IDs
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findAllFirmware$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  findAllFirmware(params?: {
    body?: SearchDto
  }): Observable<Array<CommonDetails>> {

    return this.findAllFirmware$Response(params).pipe(
      map((r: StrictHttpResponse<Array<CommonDetails>>) => r.body as Array<CommonDetails>)
    );
  }

  /**
   * Path part for operation deleteGroupEnrollment
   */
  static readonly DeleteGroupEnrollmentPath = '/api/v1/groupEnrollment/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteGroupEnrollment()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteGroupEnrollment$Response(params: {
    id: string;
  }): Observable<StrictHttpResponse<'100 CONTINUE' | '101 SWITCHING_PROTOCOLS' | '102 PROCESSING' | '103 CHECKPOINT' | '200 OK' | '201 CREATED' | '202 ACCEPTED' | '203 NON_AUTHORITATIVE_INFORMATION' | '204 NO_CONTENT' | '205 RESET_CONTENT' | '206 PARTIAL_CONTENT' | '207 MULTI_STATUS' | '208 ALREADY_REPORTED' | '226 IM_USED' | '300 MULTIPLE_CHOICES' | '301 MOVED_PERMANENTLY' | '302 FOUND' | '302 MOVED_TEMPORARILY' | '303 SEE_OTHER' | '304 NOT_MODIFIED' | '305 USE_PROXY' | '307 TEMPORARY_REDIRECT' | '308 PERMANENT_REDIRECT' | '400 BAD_REQUEST' | '401 UNAUTHORIZED' | '402 PAYMENT_REQUIRED' | '403 FORBIDDEN' | '404 NOT_FOUND' | '405 METHOD_NOT_ALLOWED' | '406 NOT_ACCEPTABLE' | '407 PROXY_AUTHENTICATION_REQUIRED' | '408 REQUEST_TIMEOUT' | '409 CONFLICT' | '410 GONE' | '411 LENGTH_REQUIRED' | '412 PRECONDITION_FAILED' | '413 PAYLOAD_TOO_LARGE' | '413 REQUEST_ENTITY_TOO_LARGE' | '414 URI_TOO_LONG' | '414 REQUEST_URI_TOO_LONG' | '415 UNSUPPORTED_MEDIA_TYPE' | '416 REQUESTED_RANGE_NOT_SATISFIABLE' | '417 EXPECTATION_FAILED' | '418 I_AM_A_TEAPOT' | '419 INSUFFICIENT_SPACE_ON_RESOURCE' | '420 METHOD_FAILURE' | '421 DESTINATION_LOCKED' | '422 UNPROCESSABLE_ENTITY' | '423 LOCKED' | '424 FAILED_DEPENDENCY' | '425 TOO_EARLY' | '426 UPGRADE_REQUIRED' | '428 PRECONDITION_REQUIRED' | '429 TOO_MANY_REQUESTS' | '431 REQUEST_HEADER_FIELDS_TOO_LARGE' | '451 UNAVAILABLE_FOR_LEGAL_REASONS' | '500 INTERNAL_SERVER_ERROR' | '501 NOT_IMPLEMENTED' | '502 BAD_GATEWAY' | '503 SERVICE_UNAVAILABLE' | '504 GATEWAY_TIMEOUT' | '505 HTTP_VERSION_NOT_SUPPORTED' | '506 VARIANT_ALSO_NEGOTIATES' | '507 INSUFFICIENT_STORAGE' | '508 LOOP_DETECTED' | '509 BANDWIDTH_LIMIT_EXCEEDED' | '510 NOT_EXTENDED' | '511 NETWORK_AUTHENTICATION_REQUIRED'>> {

    const rb = new RequestBuilder(this.rootUrl, DeviceEnrollmentControllerService.DeleteGroupEnrollmentPath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<'100 CONTINUE' | '101 SWITCHING_PROTOCOLS' | '102 PROCESSING' | '103 CHECKPOINT' | '200 OK' | '201 CREATED' | '202 ACCEPTED' | '203 NON_AUTHORITATIVE_INFORMATION' | '204 NO_CONTENT' | '205 RESET_CONTENT' | '206 PARTIAL_CONTENT' | '207 MULTI_STATUS' | '208 ALREADY_REPORTED' | '226 IM_USED' | '300 MULTIPLE_CHOICES' | '301 MOVED_PERMANENTLY' | '302 FOUND' | '302 MOVED_TEMPORARILY' | '303 SEE_OTHER' | '304 NOT_MODIFIED' | '305 USE_PROXY' | '307 TEMPORARY_REDIRECT' | '308 PERMANENT_REDIRECT' | '400 BAD_REQUEST' | '401 UNAUTHORIZED' | '402 PAYMENT_REQUIRED' | '403 FORBIDDEN' | '404 NOT_FOUND' | '405 METHOD_NOT_ALLOWED' | '406 NOT_ACCEPTABLE' | '407 PROXY_AUTHENTICATION_REQUIRED' | '408 REQUEST_TIMEOUT' | '409 CONFLICT' | '410 GONE' | '411 LENGTH_REQUIRED' | '412 PRECONDITION_FAILED' | '413 PAYLOAD_TOO_LARGE' | '413 REQUEST_ENTITY_TOO_LARGE' | '414 URI_TOO_LONG' | '414 REQUEST_URI_TOO_LONG' | '415 UNSUPPORTED_MEDIA_TYPE' | '416 REQUESTED_RANGE_NOT_SATISFIABLE' | '417 EXPECTATION_FAILED' | '418 I_AM_A_TEAPOT' | '419 INSUFFICIENT_SPACE_ON_RESOURCE' | '420 METHOD_FAILURE' | '421 DESTINATION_LOCKED' | '422 UNPROCESSABLE_ENTITY' | '423 LOCKED' | '424 FAILED_DEPENDENCY' | '425 TOO_EARLY' | '426 UPGRADE_REQUIRED' | '428 PRECONDITION_REQUIRED' | '429 TOO_MANY_REQUESTS' | '431 REQUEST_HEADER_FIELDS_TOO_LARGE' | '451 UNAVAILABLE_FOR_LEGAL_REASONS' | '500 INTERNAL_SERVER_ERROR' | '501 NOT_IMPLEMENTED' | '502 BAD_GATEWAY' | '503 SERVICE_UNAVAILABLE' | '504 GATEWAY_TIMEOUT' | '505 HTTP_VERSION_NOT_SUPPORTED' | '506 VARIANT_ALSO_NEGOTIATES' | '507 INSUFFICIENT_STORAGE' | '508 LOOP_DETECTED' | '509 BANDWIDTH_LIMIT_EXCEEDED' | '510 NOT_EXTENDED' | '511 NETWORK_AUTHENTICATION_REQUIRED'>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `deleteGroupEnrollment$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteGroupEnrollment(params: {
    id: string;
  }): Observable<'100 CONTINUE' | '101 SWITCHING_PROTOCOLS' | '102 PROCESSING' | '103 CHECKPOINT' | '200 OK' | '201 CREATED' | '202 ACCEPTED' | '203 NON_AUTHORITATIVE_INFORMATION' | '204 NO_CONTENT' | '205 RESET_CONTENT' | '206 PARTIAL_CONTENT' | '207 MULTI_STATUS' | '208 ALREADY_REPORTED' | '226 IM_USED' | '300 MULTIPLE_CHOICES' | '301 MOVED_PERMANENTLY' | '302 FOUND' | '302 MOVED_TEMPORARILY' | '303 SEE_OTHER' | '304 NOT_MODIFIED' | '305 USE_PROXY' | '307 TEMPORARY_REDIRECT' | '308 PERMANENT_REDIRECT' | '400 BAD_REQUEST' | '401 UNAUTHORIZED' | '402 PAYMENT_REQUIRED' | '403 FORBIDDEN' | '404 NOT_FOUND' | '405 METHOD_NOT_ALLOWED' | '406 NOT_ACCEPTABLE' | '407 PROXY_AUTHENTICATION_REQUIRED' | '408 REQUEST_TIMEOUT' | '409 CONFLICT' | '410 GONE' | '411 LENGTH_REQUIRED' | '412 PRECONDITION_FAILED' | '413 PAYLOAD_TOO_LARGE' | '413 REQUEST_ENTITY_TOO_LARGE' | '414 URI_TOO_LONG' | '414 REQUEST_URI_TOO_LONG' | '415 UNSUPPORTED_MEDIA_TYPE' | '416 REQUESTED_RANGE_NOT_SATISFIABLE' | '417 EXPECTATION_FAILED' | '418 I_AM_A_TEAPOT' | '419 INSUFFICIENT_SPACE_ON_RESOURCE' | '420 METHOD_FAILURE' | '421 DESTINATION_LOCKED' | '422 UNPROCESSABLE_ENTITY' | '423 LOCKED' | '424 FAILED_DEPENDENCY' | '425 TOO_EARLY' | '426 UPGRADE_REQUIRED' | '428 PRECONDITION_REQUIRED' | '429 TOO_MANY_REQUESTS' | '431 REQUEST_HEADER_FIELDS_TOO_LARGE' | '451 UNAVAILABLE_FOR_LEGAL_REASONS' | '500 INTERNAL_SERVER_ERROR' | '501 NOT_IMPLEMENTED' | '502 BAD_GATEWAY' | '503 SERVICE_UNAVAILABLE' | '504 GATEWAY_TIMEOUT' | '505 HTTP_VERSION_NOT_SUPPORTED' | '506 VARIANT_ALSO_NEGOTIATES' | '507 INSUFFICIENT_STORAGE' | '508 LOOP_DETECTED' | '509 BANDWIDTH_LIMIT_EXCEEDED' | '510 NOT_EXTENDED' | '511 NETWORK_AUTHENTICATION_REQUIRED'> {

    return this.deleteGroupEnrollment$Response(params).pipe(
      map((r: StrictHttpResponse<'100 CONTINUE' | '101 SWITCHING_PROTOCOLS' | '102 PROCESSING' | '103 CHECKPOINT' | '200 OK' | '201 CREATED' | '202 ACCEPTED' | '203 NON_AUTHORITATIVE_INFORMATION' | '204 NO_CONTENT' | '205 RESET_CONTENT' | '206 PARTIAL_CONTENT' | '207 MULTI_STATUS' | '208 ALREADY_REPORTED' | '226 IM_USED' | '300 MULTIPLE_CHOICES' | '301 MOVED_PERMANENTLY' | '302 FOUND' | '302 MOVED_TEMPORARILY' | '303 SEE_OTHER' | '304 NOT_MODIFIED' | '305 USE_PROXY' | '307 TEMPORARY_REDIRECT' | '308 PERMANENT_REDIRECT' | '400 BAD_REQUEST' | '401 UNAUTHORIZED' | '402 PAYMENT_REQUIRED' | '403 FORBIDDEN' | '404 NOT_FOUND' | '405 METHOD_NOT_ALLOWED' | '406 NOT_ACCEPTABLE' | '407 PROXY_AUTHENTICATION_REQUIRED' | '408 REQUEST_TIMEOUT' | '409 CONFLICT' | '410 GONE' | '411 LENGTH_REQUIRED' | '412 PRECONDITION_FAILED' | '413 PAYLOAD_TOO_LARGE' | '413 REQUEST_ENTITY_TOO_LARGE' | '414 URI_TOO_LONG' | '414 REQUEST_URI_TOO_LONG' | '415 UNSUPPORTED_MEDIA_TYPE' | '416 REQUESTED_RANGE_NOT_SATISFIABLE' | '417 EXPECTATION_FAILED' | '418 I_AM_A_TEAPOT' | '419 INSUFFICIENT_SPACE_ON_RESOURCE' | '420 METHOD_FAILURE' | '421 DESTINATION_LOCKED' | '422 UNPROCESSABLE_ENTITY' | '423 LOCKED' | '424 FAILED_DEPENDENCY' | '425 TOO_EARLY' | '426 UPGRADE_REQUIRED' | '428 PRECONDITION_REQUIRED' | '429 TOO_MANY_REQUESTS' | '431 REQUEST_HEADER_FIELDS_TOO_LARGE' | '451 UNAVAILABLE_FOR_LEGAL_REASONS' | '500 INTERNAL_SERVER_ERROR' | '501 NOT_IMPLEMENTED' | '502 BAD_GATEWAY' | '503 SERVICE_UNAVAILABLE' | '504 GATEWAY_TIMEOUT' | '505 HTTP_VERSION_NOT_SUPPORTED' | '506 VARIANT_ALSO_NEGOTIATES' | '507 INSUFFICIENT_STORAGE' | '508 LOOP_DETECTED' | '509 BANDWIDTH_LIMIT_EXCEEDED' | '510 NOT_EXTENDED' | '511 NETWORK_AUTHENTICATION_REQUIRED'>) => r.body as '100 CONTINUE' | '101 SWITCHING_PROTOCOLS' | '102 PROCESSING' | '103 CHECKPOINT' | '200 OK' | '201 CREATED' | '202 ACCEPTED' | '203 NON_AUTHORITATIVE_INFORMATION' | '204 NO_CONTENT' | '205 RESET_CONTENT' | '206 PARTIAL_CONTENT' | '207 MULTI_STATUS' | '208 ALREADY_REPORTED' | '226 IM_USED' | '300 MULTIPLE_CHOICES' | '301 MOVED_PERMANENTLY' | '302 FOUND' | '302 MOVED_TEMPORARILY' | '303 SEE_OTHER' | '304 NOT_MODIFIED' | '305 USE_PROXY' | '307 TEMPORARY_REDIRECT' | '308 PERMANENT_REDIRECT' | '400 BAD_REQUEST' | '401 UNAUTHORIZED' | '402 PAYMENT_REQUIRED' | '403 FORBIDDEN' | '404 NOT_FOUND' | '405 METHOD_NOT_ALLOWED' | '406 NOT_ACCEPTABLE' | '407 PROXY_AUTHENTICATION_REQUIRED' | '408 REQUEST_TIMEOUT' | '409 CONFLICT' | '410 GONE' | '411 LENGTH_REQUIRED' | '412 PRECONDITION_FAILED' | '413 PAYLOAD_TOO_LARGE' | '413 REQUEST_ENTITY_TOO_LARGE' | '414 URI_TOO_LONG' | '414 REQUEST_URI_TOO_LONG' | '415 UNSUPPORTED_MEDIA_TYPE' | '416 REQUESTED_RANGE_NOT_SATISFIABLE' | '417 EXPECTATION_FAILED' | '418 I_AM_A_TEAPOT' | '419 INSUFFICIENT_SPACE_ON_RESOURCE' | '420 METHOD_FAILURE' | '421 DESTINATION_LOCKED' | '422 UNPROCESSABLE_ENTITY' | '423 LOCKED' | '424 FAILED_DEPENDENCY' | '425 TOO_EARLY' | '426 UPGRADE_REQUIRED' | '428 PRECONDITION_REQUIRED' | '429 TOO_MANY_REQUESTS' | '431 REQUEST_HEADER_FIELDS_TOO_LARGE' | '451 UNAVAILABLE_FOR_LEGAL_REASONS' | '500 INTERNAL_SERVER_ERROR' | '501 NOT_IMPLEMENTED' | '502 BAD_GATEWAY' | '503 SERVICE_UNAVAILABLE' | '504 GATEWAY_TIMEOUT' | '505 HTTP_VERSION_NOT_SUPPORTED' | '506 VARIANT_ALSO_NEGOTIATES' | '507 INSUFFICIENT_STORAGE' | '508 LOOP_DETECTED' | '509 BANDWIDTH_LIMIT_EXCEEDED' | '510 NOT_EXTENDED' | '511 NETWORK_AUTHENTICATION_REQUIRED')
    );
  }

}
